import React from 'react';
import '../UploadForm.css';
import GeneralTooltip from '../common/GeneralTooltip.js';
import KeyIcon from '../../assets/icons/key_icon.svg';
import KeyIconMatched from '../../assets/icons/key_icon2.svg';

function JobTitleInput({ jobTitle, onChange, hasDictionaryMatch, disabled = false }) {
  return (
    <div>
      <label className="job-title-label">Job Title</label>
      <br />
      <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
        <input
          type="text"
          value={jobTitle}
          onChange={disabled ? undefined : onChange}
          placeholder="Enter the job title you're applying for..."
          className="job-title-input"
          disabled={disabled}
          aria-disabled={disabled}
        />
        {jobTitle && (
          <div className="dictionary-tooltip-container">
            <GeneralTooltip
              content={
                <div style={{ padding: '4px' }}>
                  {hasDictionaryMatch
                    ? 'Job title matched for enhanced keyword extraction'
                    : jobTitle.trim().length > 0
                    ? 'Job title not matched'
                    : 'Enter job title to analyze'}
                </div>
              }
              position="top"
              delay={100}
              verticalOffset={8}
              triggerClassName="dictionary-match-icon-container"
            >
              <div className="dictionary-match-icon-container">
                <img
                  src={hasDictionaryMatch ? KeyIconMatched : KeyIcon}
                  alt={hasDictionaryMatch ? 'Job title recognized' : 'Analyzing job title'}
                  className={`dictionary-match-icon visible ${hasDictionaryMatch ? 'matched' : 'checking'}`}
                />
              </div>
            </GeneralTooltip>
          </div>
        )}
      </div>
    </div>
  );
}

export default JobTitleInput;


